<ng-container *ngIf="showInfoAsTooltip; else labelWithDescription">
  <label class="weight-500 {{ labelClass }}">
    {{ label }}<span *ngIf="required">*</span>
    <nb-icon
      icon="info-outline"
      pack="fci"
      [nbTooltip]="toolTip"
      *ngIf="toolTip"
      class="toolTip-icon ml-2"
      status="info"
      style="font-size: 1.25em"
    ></nb-icon>
  </label>
</ng-container>
<ng-template #labelWithDescription>
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center">
      <label
        [ngClass]="{ 'weight-500 mb-0': 1, 'label-link': link?.length }"
        (click)="openLinkInNewTab()"
        >{{ label }}<span *ngIf="required && label?.length > 0">*</span></label
      >
      <nb-icon
        class="ml-2"
        *ngIf="customIcon"
        [icon]="customIcon?.icon"
        [ngClass]="customIcon?.class"
        [status]="customIcon?.status || 'primary'"
        [pack]="customIcon?.pack || 'fci'"
        (click)="customIconClick($event)"
      ></nb-icon>
    </div>
    <p class="label-description" [innerHTML]="toolTip"></p>
  </div>
</ng-template>
